'use strict';

window.dataLayer = window.dataLayer || [];

(function () {
  var CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  var BONUS_PREFIX = 'offer-pack-bonus-';
  var lastMutationType = null;  // 'add' | 'remove' | 'quantity_update' — set by the fetch layer
  var lastCartItems = {};       // raw /cart.js lines (by key / variant id / line index), kept so a removal can rebuild the full item
  var lastAddPushAt = 0;        // when add_to_cart was last pushed (any layer) — gates the burst fallback
  var addLedger = {};           // variant_id -> { qty, at } pushed by the fetch layer, consumed by variant:add
  var ADD_DEDUPE_MS = 3000;     // ledger TTL + burst-fallback gate
  var isLocalDev = ['127.0.0.1', 'localhost'].indexOf(window.location.hostname) !== -1;
  // Local dev always logs; in production the theme setting `datalayer_debug_log` toggles it.
  var debugLog = isLocalDev || window.dataLayerDebug === true;

  // Per-event-type badge colour for the local console log.
  var LOG_COLORS = {
    'add_to_cart': '#2e7d32', 'variant:add': '#2e7d32',
    'remove_from_cart': '#c62828',
    'view_item': '#1565c0', 'item:view': '#1565c0', 'view_cart': '#1565c0',
    'page_view': '#455a64',
    'variant:change': '#e65100',
    'multi-add-to-cart:change': '#ad1457',
    'cart:change': '#6a1b9a',
    'line-item:change': '#5c6bc0',
    'begin_checkout': '#00838f'
  };

  function logPush(eventName, payload) {
    var ecom = payload.ecommerce || {};
    var color = LOG_COLORS[eventName] || '#555';
    var first = ecom.items && ecom.items[0];

    // Title — option value(s) (+N more)
    var label = '';
    if (first) {
      label = first.item_name || first.item_group_title || first.item_id || '';
      var variant = first.item_variant || first.item_title;
      if (variant) label += ' — ' + variant;
      if (ecom.items.length > 1) label += ' (+' + (ecom.items.length - 1) + ' more)';
    }

    var summary = [];
    if (ecom.value != null) summary.push('💰 ' + ecom.value + ' ' + (ecom.currency || ''));
    if (payload.change_type) summary.push('🔁 ' + payload.change_type);
    if (first && first.pack_selected) summary.push('📦 pack');
    if (first && first.configuration_state) summary.push(first.configuration_state);
    if (ecom.items) summary.push('🛒 ' + ecom.items.length);

    console.groupCollapsed(
      '%c dataLayer %c ' + eventName + ' %c ' + label + (label && summary.length ? '   •   ' : '') + summary.join('   '),
      'background:#202124;color:#fff;padding:2px 6px;border-radius:3px 0 0 3px;font-weight:bold;',
      'background:' + color + ';color:#fff;padding:2px 6px;border-radius:0 3px 3px 0;font-weight:bold;',
      'color:#9aa0a6;'
    );
    if (ecom.items && ecom.items.length) {
      try {
        console.table(ecom.items.map(function (it) {
          return {
            item_id: it.item_id, item_group_id: it.item_group_id,
            title: it.item_title || it.item_name, variant: it.item_variant,
            price: it.price, compare: it.compare_price, discount: it.discount, '%': it.discount_percent,
            qty: it.quantity, sku: it.item_sku, brand: it.item_brand, category: it.item_category,
            pack: it.pack_selected, state: it.configuration_state
          };
        }));
      } catch (e) { console.log('items:', ecom.items); }
    }
    console.log('payload:', payload);
    console.groupEnd();
  }

  // Single funnel for every dataLayer push — pretty-logs locally when isLocalDev.
  function dlPush(eventName, ecommerce, extra) {
    var payload = { event: eventName, ecommerce: ecommerce };
    if (extra) { for (var k in extra) { if (extra.hasOwnProperty(k)) payload[k] = extra[k]; } }
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(payload);
    if (debugLog) logPush(eventName, payload);
  }

  // page_view is pushed server-side (datalayer-page-view.liquid) before this script,
  // so it bypasses dlPush — surface it in the debug log too (with its page/user payload).
  if (debugLog) {
    var _pv = (window.dataLayer || []).filter(function (e) { return e && e.event === 'page_view'; }).pop();
    if (_pv) logPush('page_view', _pv);
  }

  // Canonical GA4 item — item_* = variant level, item_group_* = product level.
  // Every event builds its items through here so the shape is identical everywhere.
  function buildItem(o) {
    o = o || {};
    var price = +o.price || 0;
    var compare = (o.compare_price != null) ? (+o.compare_price || 0) : price;
    return {
      item_id:            o.item_id != null ? String(o.item_id) : '',
      item_group_id:      o.item_group_id != null ? String(o.item_group_id) : '',
      item_group_title:   o.item_group_title || '',
      item_sku:           o.item_sku || '',
      item_name:          o.item_name || '',
      item_brand:         o.item_brand || '',
      item_variant:       o.item_variant || '',
      item_title:         o.item_title || '',
      item_category:      o.item_category || '',
      item_url:           o.item_url || '',
      image_url:          o.image_url || '',
      price:              price,
      compare_price:      compare,
      discount:           (o.discount != null) ? (+o.discount || 0) : Math.max(0, compare - price),
      discount_percent:   (compare > 0 && compare > price) ? Math.round((compare - price) / compare * 1000) / 10 : 0,
      currency:           o.currency || CURRENCY,
      availability:       (o.availability != null) ? !!o.availability : true,
      inventory_quantity: (o.inventory_quantity != null) ? o.inventory_quantity : 0,
      configuration_state: o.configuration_state || 'resolved',
      pack_selected:      !!o.pack_selected,
      quantity:           (o.quantity != null) ? o.quantity : 1
    };
  }

  // Maps a Shopify cart / cart-add line to a canonical item.
  function itemFromCartLine(line, qty) {
    var finalP = (line.final_price != null ? line.final_price : line.price);
    var origP  = (line.original_price != null ? line.original_price : line.price);
    return buildItem({
      item_id:          line.variant_id,
      item_group_id:    line.product_id,
      item_group_title: line.product_title,
      item_sku:         line.sku,
      item_name:        line.product_title,
      item_brand:       line.vendor,
      item_variant:     line.variant_title,
      item_title:       line.variant_title,
      item_category:    line.product_type,
      item_url:         line.url,
      image_url:        line.image,
      price:            finalP / 100,
      compare_price:    origP / 100,
      currency:         line.currency || CURRENCY,
      quantity:         qty != null ? qty : line.quantity
    });
  }

  // Index the current cart lines so a later removal can rebuild the full item.
  function cacheCartItems(cart) {
    lastCartItems = {};
    (cart.items || []).forEach(function (line, i) {
      lastCartItems[line.key] = line;
      lastCartItems[String(line.variant_id)] = line;
      lastCartItems[String(i + 1)] = line; // 1-based line index
    });
  }

  // Build a remove_from_cart item from the cached line (key, variant id, or line index).
  function removedItem(idOrKey) {
    var line = lastCartItems[String(idOrKey)];
    if (line) return itemFromCartLine(line, line.quantity);
    return buildItem({ item_id: String(idOrKey).split(':')[0] || idOrKey }); // fallback: variant id from "variantId:hash"
  }

  // add_to_cart / variant:add from raw Shopify add-line(s). Shared by the DOM
  // variant:add listener (fetch-independent, primary) and the fetch burst (fallback).
  function pushAdd(lines) {
    var items = (lines || []).map(function (it) { return itemFromCartLine(it); });
    if (!items.length) return false;
    var value = Math.round(items.reduce(function (s, it) { return s + it.price * it.quantity; }, 0) * 100) / 100;
    var ecom = { currency: CURRENCY, value: value, items: items };
    dlPush('add_to_cart', ecom); // legacy GA4 name
    dlPush('variant:add', ecom); // custom name
    lastAddPushAt = Date.now();
    return true;
  }

  // The fetch layer and the variant:add listener both fire for the same physical add,
  // in either order (their JSON parses race). Whoever runs first pushes and records;
  // the second consumes the record and stays silent.
  function ledgerRecord(lines) {
    var now = Date.now();
    (lines || []).forEach(function (l) {
      var id = String(l.variant_id);
      var prev = addLedger[id];
      var qty = (prev && now - prev.at < ADD_DEDUPE_MS ? prev.qty : 0) + (l.quantity || 1);
      addLedger[id] = { qty: qty, at: now };
    });
  }

  // Subtract ledgered quantities from lines — returns only the not-yet-pushed remainder.
  function ledgerConsume(lines) {
    var now = Date.now();
    var out = [];
    (lines || []).forEach(function (l) {
      var id = String(l.variant_id);
      var entry = addLedger[id];
      var have = (entry && now - entry.at < ADD_DEDUPE_MS) ? entry.qty : 0;
      var want = l.quantity || 1;
      if (have >= want) { entry.qty = have - want; return; }
      var clone = l;
      if (have > 0) {
        entry.qty = 0;
        clone = {};
        for (var k in l) { if (l.hasOwnProperty(k)) clone[k] = l[k]; }
        clone.quantity = want - have;
      }
      out.push(clone);
    });
    return out;
  }

  // Race-safe entry point for the two primary layers (fetch + variant:add).
  function pushAddOnce(lines) {
    var remainder = ledgerConsume(lines);
    if (pushAdd(remainder)) ledgerRecord(remainder);
  }

  // Primary add signal: the DOM variant:add event fires on every native add and
  // does NOT depend on our fetch wrapper (which other scripts like Klaviyo can clobber).
  // Capture phase on document so it runs BEFORE any stopImmediatePropagation from
  // listeners deeper in the tree (the add-to-cart popup blocks variant:add on
  // documentElement — observed in prod: add_to_cart lost on popup products).
  document.addEventListener('variant:add', function (e) {
    pushAddOnce(e.detail && e.detail.items);
  }, true);

  // ─── Cart mutations (fetch layer) ────────────────────────────────────────────
  // /cart/add is unambiguously an add; /cart/change|update drive quantity/remove.
  function handleCartFetch(url, init, promise) {
    if (url.indexOf('/cart/add') !== -1) {
      lastMutationType = 'add';
      // Push add_to_cart the moment the response resolves — survives quick navigations
      // (redirect-to-cart) and doesn't depend on the burst. pushAddOnce dedupes
      // against the variant:add dispatched for this same add.
      promise
        .then(function (r) { return r.ok ? r.clone().json() : null; })
        .then(function (data) {
          if (data) {
            var lines = (data.items || [data]).filter(function (it) { return it && it.variant_id; });
            if (lines.length) pushAddOnce(lines);
          }
        })
        .catch(function () {})
        .then(scheduleCartUpdate);
    } else if (url.indexOf('/cart/change') !== -1) {
      // Per-line change — same endpoint for the cart page and the minicart/drawer.
      var cbody; try { cbody = init && init.body ? JSON.parse(init.body) : null; } catch (e) {}
      var chKey = cbody ? (cbody.id || cbody.line) : null;
      var chNewQty = cbody ? Number(cbody.quantity) : NaN;
      var chPrev = chKey != null ? lastCartItems[String(chKey)] : null;
      var chOldQty = chPrev ? chPrev.quantity : 0;
      var chDelta = isNaN(chNewQty) ? 0 : (chNewQty - chOldQty);
      var isRemove = !isNaN(chNewQty) && chNewQty === 0;
      lastMutationType = isRemove ? 'remove' : 'quantity_update';

      if (chKey != null && !isNaN(chNewQty)) {
        // Dedicated per-line event carrying the changed line + old/new/delta.
        dlPush('line-item:change',
          { currency: (chPrev && chPrev.currency) || CURRENCY, items: [chPrev ? itemFromCartLine(chPrev, chNewQty) : removedItem(chKey)] },
          { change_type: chDelta > 0 ? 'increase' : (chDelta < 0 ? 'decrease' : 'none'), old_quantity: chOldQty, new_quantity: chNewQty, delta: chDelta });

        // Delta-aware GA4 events: increase -> add_to_cart, decrease -> remove_from_cart (both with the delta only).
        if (chDelta > 0 && chPrev) {
          dlPush('add_to_cart', { currency: chPrev.currency || CURRENCY, items: [itemFromCartLine(chPrev, chDelta)] });
        } else if (chDelta < 0 && chNewQty > 0) {
          var decItem = chPrev ? itemFromCartLine(chPrev, -chDelta) : removedItem(chKey);
          dlPush('remove_from_cart', { currency: decItem.currency || CURRENCY, items: [decItem] });
        } else if (isRemove) {
          var rItem = removedItem(chKey);
          dlPush('remove_from_cart', { currency: rItem.currency || CURRENCY, items: [rItem] });
        }

        // Keep the cache in sync so a rapid second change computes its delta from the updated baseline.
        if (chPrev && chNewQty > 0) chPrev.quantity = chNewQty;
      }
      scheduleCartUpdate();
    } else if (url.indexOf('/cart/update') !== -1) {
      // Only line-quantity updates count — ignore attribute/note-only updates (e.g. _subdomain).
      var ubody; try { ubody = init && init.body ? JSON.parse(init.body) : null; } catch (e) {}
      if (ubody && ubody.updates) {
        var removedKeys = [];
        for (var k in ubody.updates) {
          if (ubody.updates.hasOwnProperty(k) && Number(ubody.updates[k]) === 0) removedKeys.push(k);
        }
        lastMutationType = removedKeys.length ? 'remove' : 'quantity_update';
        if (removedKeys.length) {
          var rItems = removedKeys.map(removedItem);
          dlPush('remove_from_cart', { currency: rItems[0].currency || CURRENCY, items: rItems });
        }
        scheduleCartUpdate();
      }
    }
  }

  // Other scripts (Klaviyo, pixels, consent tools) also overwrite window.fetch and
  // may load AFTER us, wiping our /cart/add interception (observed in prod: add_to_cart
  // lost). Re-assert the wrapper on load + a few delays; only the newest install
  // processes (activeInstall guard), so a re-wrapped chain never double-counts.
  var activeInstall = 0;

  function makeFetchWrap(prevFetch, installId) {
    return function (input, init) {
      var promise = prevFetch.apply(this, arguments);
      if (installId === activeInstall) {
        var url = (typeof input === 'string' ? input : (input && input.url)) || '';
        handleCartFetch(url, init, promise);
      }
      return promise;
    };
  }

  function installFetchWrap() {
    if (typeof window.fetch !== 'function') return;
    if (window.fetch.__dlWrapped && window.fetch.__dlId === activeInstall) return;
    activeInstall++;
    var wrapped = makeFetchWrap(window.fetch, activeInstall);
    wrapped.__dlWrapped = true;
    wrapped.__dlId = activeInstall;
    window.fetch = wrapped;
  }

  installFetchWrap();
  window.addEventListener('load', installFetchWrap);
  [800, 2000, 4000, 8000].forEach(function (ms) { setTimeout(installFetchWrap, ms); });

  // ─── begin_checkout ──────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('[name="checkout"], [href*="/checkout"], .cart__checkout-button')) return;
    if (window.dataLayerCartData) dlPush('begin_checkout', window.dataLayerCartData);
  });

  // ─── GA4 _custom events (names mirror the source DOM events) ──────────────────
  // item:view is pushed once on load (further down, via dlPush).
  function packSelected() {
    return !!document.querySelector('[data-offer-pack-card="pack"][aria-pressed="true"]');
  }

  // variant.price is the full Shopify price (no theme offer); the re-rendered price
  // block reflects the offer (e.g. multi_add_offer -25%) — read the shown price there.
  function parseMoney(text) {
    if (!text) return null;
    var c = text.replace(/[^0-9.,]/g, '');
    if (!c) return null;
    if (c.indexOf(',') > -1) c = c.replace(/\./g, '').replace(',', '.'); // FR: . thousands, , decimal
    var n = parseFloat(c);
    return isNaN(n) ? null : n;
  }
  function readMainPrice() {
    var pl = document.querySelector('.price-block price-list');
    if (!pl) return null;
    var sale = parseMoney((pl.querySelector('sale-price') || {}).textContent);
    if (sale == null) return null;
    var cmp = parseMoney((pl.querySelector('compare-at-price') || {}).textContent);
    return { price: sale, compare: (cmp != null && cmp > sale) ? cmp : sale };
  }

  // ── variant:change (variant / pack selected) ──
  var variantTimer = null;
  // Seed with the PDP's initial variant so the components' connect-time
  // multi-add-to-cart:change doesn't fire a selection on load.
  var lastVariantKey = window.dataLayerCurrentProduct
    ? String(window.dataLayerCurrentProduct.item_id) + ':false'
    : '';

  function fireVariantSelected(variant) {
    if (!variant || !variant.id) return;
    var base = window.dataLayerCurrentProduct || {};
    var pack = packSelected();
    var key = String(variant.id) + ':' + pack;

    clearTimeout(variantTimer);
    variantTimer = setTimeout(function () {
      if (key === lastVariantKey) return; // no real option change
      lastVariantKey = key;

      var dom = readMainPrice();
      var vprice = dom ? dom.price : ((variant.price != null ? variant.price : 0) / 100);
      var vcompare = dom ? dom.compare
        : ((variant.compare_at_price != null && variant.compare_at_price > variant.price) ? variant.compare_at_price / 100 : vprice);
      var item = buildItem({
        item_id:           variant.id,
        item_group_id:     base.item_group_id,
        item_group_title:  base.item_group_title || base.item_name,
        item_sku:          variant.sku || base.item_sku,
        item_name:         base.item_name,
        item_brand:        base.item_brand,
        item_variant:      variant.title,
        item_title:        variant.title,
        item_category:     base.item_category,
        item_url:          base.item_url,
        image_url:         base.image_url,
        price:             vprice,
        compare_price:     vcompare,
        configuration_state: 'resolved',
        pack_selected:     pack
      });
      dlPush('variant:change', { currency: CURRENCY, value: vprice, items: [item] });
    }, 60);
  }

  document.addEventListener('variant:change', function (e) {
    if (e.detail && e.detail.variant) fireVariantSelected(e.detail.variant);
  });

  // Per-unit price after the line's offer (mirrors component-multi-add-to-cart).
  function lineUnitFinal(l) {
    var full = l.price || 0;
    if (l.compareAtPrice != null) return full; // offer-pack: price is already final
    if (!l.discount) return full;
    if (l.discountUnit === '%') {
      if (l.mainSharePrice != null) {
        var share = Math.round(full * (100 - l.discount) / 100);
        var bonusPP = Math.max(0, l.discount - (l.soloDiscount || 0));
        return share - Math.round(l.mainSharePrice * bonusPP / 100);
      }
      return Math.round(full * (1 - l.discount / 100));
    }
    return Math.max(0, full - l.discount * 100);
  }

  // ── multi-add-to-cart:change (offer-pack / multi-add selection) ──
  // Mirrors the component event as its own dataLayer event, carrying the current
  // selection lines as items.
  var lastMacKey = '';
  var macInitAt = Date.now();
  var suppressMacUntil = 0;

  // A native variant change re-renders the product section, which re-connects the
  // multi-add components and makes them re-dispatch multi-add-to-cart:change. Those
  // aren't user selections — suppress them briefly around the option change (this
  // fires before the re-render). Real multi-add interactions don't change options.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[data-option-position]')) suppressMacUntil = Date.now() + 1500;
  }, true);

  document.addEventListener('multi-add-to-cart:change', function (e) {
    var lines = ((e.detail && e.detail.lines) || []).filter(function (l) { return (l.qty || 0) > 0; });
    var base = window.dataLayerCurrentProduct || {};
    var pack = packSelected();
    var packCard = pack ? document.querySelector('[data-offer-pack-card="pack"][aria-pressed="true"]') : null;
    var packQty = packCard ? (parseInt(packCard.dataset.offerPackQuantity, 10) || 1) : 1;
    var key = pack + '|' + lines.map(function (l) { return l.variantId + ':' + l.qty; }).join(',');

    if (Date.now() - macInitAt < 1500 || Date.now() < suppressMacUntil) { lastMacKey = key; return; }
    if (!lines.length) { lastMacKey = key; return; } // empty selection — nothing to report
    if (key === lastMacKey) return;                  // unchanged selection
    lastMacKey = key;

    var items = lines.map(function (l) {
      var rawId = String(l.variantId || '');
      var isMain = rawId.indexOf(BONUS_PREFIX) === 0 || rawId === String(base.item_id);
      var src = isMain ? {
        item_id: base.item_id, item_group_id: base.item_group_id, item_group_title: base.item_group_title,
        item_sku: base.item_sku, item_name: base.item_name, item_brand: base.item_brand,
        item_variant: base.item_variant, item_title: base.item_title, item_category: base.item_category,
        item_url: base.item_url, image_url: base.image_url
      } : {
        item_id: rawId, item_group_id: l.productId, item_group_title: l.productTitle,
        item_sku: l.sku, item_name: l.productTitle, item_brand: l.vendor,
        item_variant: l.variantTitle, item_title: l.variantTitle, item_category: l.category,
        item_url: l.url, image_url: l.image
      };
      var full = (l.compareAtPrice != null) ? l.compareAtPrice : (l.price || 0);
      var unitFinal = lineUnitFinal(l);
      var qty = l.qty;
      // Offer-pack pack line is ONE line at the whole-pack price — report it as the
      // pack quantity at the per-unit price (qty × price = pack total).
      if (rawId.indexOf(BONUS_PREFIX) === 0 && packQty > 1) {
        qty = packQty;
        unitFinal = Math.round(unitFinal / packQty);
        full = Math.round(full / packQty);
      }
      src.price = unitFinal / 100;
      src.compare_price = full / 100;
      src.quantity = qty;
      src.pack_selected = pack;
      return buildItem(src);
    });

    var value = items.reduce(function (s, it) { return s + it.price * it.quantity; }, 0);
    dlPush('multi-add-to-cart:change', { currency: CURRENCY, value: Math.round(value * 100) / 100, items: items });
  });

  // ── variant:add + cart:change ──
  var prevCart = null;     // { count, total, lines: { key: qty } }
  var burstTimer = null;

  function snapshot(cart) {
    var lines = {};
    (cart.items || []).forEach(function (it) { lines[it.key] = it.quantity; });
    return { count: cart.item_count, total: cart.total_price, lines: lines };
  }

  // Added line(s) inferred from the before/after cart diff — the catch-all when
  // neither the fetch wrapper nor variant:add captured the add. quantity = the
  // increase only.
  function addedLinesFromDiff(cart, prev) {
    if (!prev) return [];
    var out = [];
    (cart.items || []).forEach(function (line) {
      var delta = line.quantity - (prev.lines[line.key] || 0);
      if (delta <= 0) return;
      var clone = {};
      for (var k in line) { if (line.hasOwnProperty(k)) clone[k] = line[k]; }
      clone.quantity = delta;
      out.push(clone);
    });
    return out;
  }

  function classifyAndPush(cart) {
    var snap = snapshot(cart);

    // Empty read is only real when a removal emptied the cart; else it's stale/spurious.
    if (snap.count === 0 && lastMutationType !== 'remove') {
      prevCart = snap;
      lastMutationType = null;
      return;
    }

    // No mutation flagged → only emit on a confirmed diff vs a known baseline.
    if (!lastMutationType && (!prevCart || (snap.count === prevCart.count && snap.total === prevCart.total))) {
      prevCart = snap;
      return;
    }

    // change_type from the fetch layer when known; else fall back to a cart diff.
    var changeType = lastMutationType;
    if (!changeType) {
      changeType = 'quantity_update';
      if (prevCart) {
        var hasNewKey = Object.keys(snap.lines).some(function (k) { return !(k in prevCart.lines); });
        var hasRemovedKey = Object.keys(prevCart.lines).some(function (k) { return !(k in snap.lines); });
        if (hasNewKey || snap.count > prevCart.count) changeType = 'add';
        else if (hasRemovedKey || snap.count < prevCart.count) changeType = 'remove';
      }
    }

    dlPush('cart:change', {
      currency: cart.currency || CURRENCY,
      value: cart.total_price / 100,
      items: (cart.items || []).map(function (it) { return itemFromCartLine(it); })
    }, { change_type: changeType });

    // add_to_cart — the fetch layer and the variant:add listener are the primary
    // signals; this burst is the catch-all for paths where BOTH were missed (fetch
    // wrapper clobbered AND no variant:add dispatched). Skip when a push already
    // happened for this burst. A brand-new line key is unambiguously an add even
    // when the coalesced type isn't 'add' (e.g. a qty-change + add in one burst);
    // existing-line increases stay gated to 'add' so cart-page qty changes aren't
    // double-counted with line-item:change.
    if (Date.now() - lastAddPushAt > ADD_DEDUPE_MS) {
      var addLines = addedLinesFromDiff(cart, prevCart);
      if (changeType !== 'add') {
        addLines = addLines.filter(function (l) { return prevCart && !(l.key in prevCart.lines); });
      }
      if (addLines.length) pushAdd(addLines);
    }

    prevCart = snap;
    lastMutationType = null;
  }

  // Coalesce a burst into one fetch+push. cart:change / cart:refresh re-arm the
  // timer, so a plain debounce would wait "1500ms after the LAST event" (~3s).
  // BURST_MAXWAIT caps the total delay measured from the FIRST trigger.
  var BURST_WINDOW = 600;   // quiet-period debounce
  var BURST_MAXWAIT = 1200; // hard cap from the first trigger of the burst
  var burstStartedAt = 0;

  function runCartUpdate() {
    burstTimer = null;
    burstStartedAt = 0;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) { cacheCartItems(cart); classifyAndPush(cart); } })
      .catch(function () {});
  }

  function scheduleCartUpdate() {
    var now = Date.now();
    if (!burstStartedAt) burstStartedAt = now;
    clearTimeout(burstTimer);
    var wait = Math.min(BURST_WINDOW, Math.max(0, burstStartedAt + BURST_MAXWAIT - now));
    burstTimer = setTimeout(runCartUpdate, wait);
  }

  document.addEventListener('cart:change', scheduleCartUpdate);
  document.addEventListener('cart:refresh', scheduleCartUpdate);

  // Baseline cart so the first change classifies correctly. Seed SYNCHRONOUSLY from
  // the server-rendered cart — an async /cart.js can resolve AFTER the first add on
  // heavy pages (matelas), leaving prevCart = the post-add state so the diff sees
  // nothing. The /cart.js refine below only fills the line cache; it never re-stales
  // prevCart (maintained by classifyAndPush thereafter).
  if (window.dataLayerInitialCart && window.dataLayerInitialCart.items) {
    prevCart = snapshot(window.dataLayerInitialCart);
    cacheCartItems(window.dataLayerInitialCart);
  }
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (cart) { if (cart) { cacheCartItems(cart); if (!prevCart) prevCart = snapshot(cart); } })
    .catch(function () {});

  // ── item:view — once on PDP load (item not yet configured) ──
  if (window.dataLayerCurrentProduct) {
    var vi = window.dataLayerCurrentProduct;
    var viDom = readMainPrice();
    var viPrice = viDom ? viDom.price : (+vi.price || 0);
    var viCompare = viDom ? viDom.compare : (+vi.compare_price || viPrice);
    dlPush('item:view', {
      currency: vi.currency || CURRENCY,
      value: viPrice,
      items: [buildItem({
        item_id: vi.item_id, item_group_id: vi.item_group_id, item_group_title: vi.item_group_title,
        item_sku: vi.item_sku, item_name: vi.item_name, item_brand: vi.item_brand,
        item_variant: vi.item_variant, item_title: vi.item_title, item_category: vi.item_category,
        item_url: vi.item_url, image_url: vi.image_url, inventory_quantity: vi.inventory_quantity,
        price: viPrice, compare_price: viCompare, configuration_state: 'unresolved', pack_selected: false, quantity: 1
      })]
    });
  }
})();
